import { ApplicationUser } from '../types/ApplicationUser';
import { getJson } from './Utils';

async function getCurrentUser(): Promise<ApplicationUser> {
  const response = await fetch('/api/User');
  return (await getJson(response)) as ApplicationUser;
}

export default {
  getCurrentUser,
};
